<template>
  <section id="CufeDiscount">

      <div class="columns">
        <div class="column search-control">
          <b-field label="Buscar tercero">
            <div class="control-content">
              <EntityAutocomplete
                v-model="entity"
                label="name"
                v-validate="'required'"
                name="entity"
                ref="autocomplete"/>
            </div>
          </b-field>
          <span class="show-error">{{ errors.first("entity") }}</span>
        </div>
        <div class="column">
        </div>
      </div>

      <!-- Tienda -->
      <div class="columns" v-if="entity.code">
        <div class="column">
          <b-field label="Nombre">
            <b-input v-model="entity.name" disabled></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Documento">
            <b-input v-model="entity.identification" disabled>
            </b-input>
          </b-field>
        </div>


        <!-- Rangos -->

        <div class="column">
          <b-field label="Valor inicial">
            <b-input
              v-model.number="initialValue"
              type="text"
              v-validate="'required'"
              name="initialValue"
              @keypress.native="onlyNumbers">
            </b-input>
          </b-field>
          <span class="show-error">{{ errors.first("initialValue") }}</span>
        </div>

        <div class="column">
          <b-field label="Valor final">
            <b-input
              v-model.number="finalValue"
              type="text"
              v-validate="'required'"
              name="finalValue"
              @keypress.native="onlyNumbers">
            </b-input>
          </b-field>
          <span class="show-error">{{ errors.first("finalValue") }}</span>
        </div>

        <div class="column">
          <b-field label="Descuentos">
          <b-select
            v-model="voucher"
            placeholder="Seleccione un descuento"
            v-validate="'required'"
            name="voucher">

            <option
              v-for="item in discounts"
              :key="item.code"
              :value="item">

              {{ item.title }}

            </option>

          </b-select>

          <span class="show-error">{{ errors.first("voucher") }}</span>
          </b-field>
        </div>
      </div>

      <div class="buttons button-group">
        <b-button
          @click="saveCufe()"
          title="Guardar cambios"
          icon-left="content-save"
          type="is-info"
        >
          Guardar cambios
        </b-button>
        <b-button
          @click="cleanForm()"
          icon-left="backspace"
          v-if="id != null"
          type="is-dark"
          title="Limpiar"
        >Limpiar
        </b-button>
        <b-button
          @click="openDeleteModal()"
          v-if="id != null"
          type="is-danger"
          title="Eliminar"
          icon-left="delete"
        >Eliminar
        </b-button>
      </div>


      <!-- Tabla -->

      <div class="columns">
        <div class="column">
          <div class = "discount-table-cufe">
            <vs-table
              :key="tableKey"
              search
              pagination
              :max-items="10"
              :data="tableData">

              <!-- Cabecera -->
              <template slot="thead">
                <vs-th>Valor inicial</vs-th>
                <vs-th>Valor final</vs-th>
                <vs-th>Descuento</vs-th>
                <vs-th>Tienda</vs-th>
                <vs-th>Documento</vs-th>
                <vs-th width="80">Acción</vs-th>
              </template>

              <!-- Registros -->
              <template slot-scope="{ data }">

                <vs-tr
                  v-for="item in data"
                  :key="item.code"
                  :class="{ 'is-selected': selected && selected.code === item.code }">
                  <vs-td :data="item.ranges.initialvalue">
                    {{ item.ranges.initialValue }}
                  </vs-td>
                  <vs-td :data="item.ranges.finalvalue">
                    {{ item.ranges.finalValue }}
                  </vs-td>
                  <vs-td :data="item.voucher.title">
                    {{ item.voucher.title }}
                  </vs-td>
                  <vs-td :data="item.client.name">
                    {{ item.client.name }}
                  </vs-td>
                  <vs-td :data="item.client.identification">
                    {{ item.client.identification }}
                  </vs-td>
                  <vs-td>
                    <button
                      class="btn primary edit"
                      title="Seleccionar"
                      @click="select(item)">
                    <span class="material-icons">edit</span>
                    </button>
                  </vs-td>
                </vs-tr>

              </template>

              <template slot="notFound">
                <span>No existen registros.</span>
              </template>

            </vs-table>
          </div>
        </div>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

  </section>
</template>

<script>

import EntityAutocomplete from '@/components/Shared/Autocomplete/EntityAutocomplete.vue'
import {ROUTES} from "@/global/api_routes";
import {confirmation} from "@/global/utils";
import {configToast, TOAST_TYPES} from "@/global/toast";

export default {
  name: "CufeDiscount",
  components: { EntityAutocomplete },
  props: {
    company: {
      type: [String, Number],
      default: null
    },
    discounts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      entity: {
        code: null,
        identification: '',
        name: ''
      },
      id: null,
      isLoading: false,
      initialValue: null,
      finalValue: null,
      voucher: null,
      selected: null,
      tableData: [],
      tableKey: 0,
      client_id: null,


    }
  },

  mounted(){
    this.getCufeDiscounts();
  }
  ,
  watch: {
    discounts() {
      // Si cambia la lista de descuentos (p.ej. cambió la compañía),
      // la selección anterior ya no es válida.
      this.voucher = null
    },
    company() {
      this.cleanForm()
      this.getCufeDiscounts()
    }
  }
  ,
  methods: {

    onlyNumbers(event) {
      const code = event.which || event.keyCode
      if (code < 48 || code > 57) {
        event.preventDefault()
      }
    }
    ,
    select(item) {
      console.log("SELECIONADSO .....",item);
      this.selected = item
      this.id = item.code
      this.entity = { ...item.client }
      this.entity = {
        code: item.client.code,
        identification: item.client.identification,
        name: item.client.name
      }
      this.initialValue = item.ranges.initialValue
      this.finalValue = item.ranges.finalValue
      this.voucher = this.discounts.find(d => d.code === item.voucher.code) || null
      this.client_id = item.client.id
    },

    cleanForm() {
      this.$validator.pause();
      this.id = null
      this.selected = null
      this.initialValue = null
      this.finalValue = null
      this.entity = {
        code: null,
        identification: '',
        name: ''
      }
      this.voucher = null
      this.client_id = null
      if (this.$refs.autocomplete) {
        if (typeof this.$refs.autocomplete.newValue === 'function') {
          this.$refs.autocomplete.newValue('');
        }
        else if (this.$refs.autocomplete.$refs.autocomplete) {
          this.$refs.autocomplete.$refs.autocomplete.newValue = '';
        }
        else if (typeof this.$refs.autocomplete.clear === 'function') {
          this.$refs.autocomplete.clear();
        }
        else if (typeof this.$refs.autocomplete.clean === 'function') {
          this.$refs.autocomplete.clean();
        }
        const inputElement = this.$refs.autocomplete.$el.querySelector('input');
        if (inputElement) {
          inputElement.value = '';
        }
      }
    },

    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#CufeDiscount");
      return instance.open(message, type);
    },

    /**
     * Arma el objeto que se envía al backend a partir del estado del formulario.
     */
    getCufeObject() {
      return {
        code: this.id,
        company: {code: this.company},
        client: {code: this.entity.code},
        voucher: {code: this.voucher.code},
        ranges: {
          code: this.id,
          initialValue: Number(this.initialValue),
          finalValue: Number(this.finalValue)
        }
      }
    },

    /**
     * Validaciones de negocio que v-validate no cubre
     * (relación entre campos, no solo si están vacíos).
     */
    validateCufeForm() {
      if (!this.entity || !this.entity.code) {
        throw new Error("Debe seleccionar un tercero");
      }
      if (!this.voucher || !this.voucher.code) {
        throw new Error("Debe seleccionar un descuento");
      }
      if (this.initialValue === null || this.finalValue === null) {
        throw new Error("Debe ingresar el valor inicial y final del rango");
      }
      if (Number(this.finalValue) < Number(this.initialValue)) {
        throw new Error("El valor final no puede ser menor al valor inicial");
      }
    },

    saveCufe() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.toast("No se pudo guardar. Revisa el formulario", TOAST_TYPES.ERROR);
          return;
        }
        try {
          this.validateCufeForm();
        } catch (error) {
          this.toast(error.message, TOAST_TYPES.ERROR);
          return;
        }
        this.isLoading = true;
        const send = this.getCufeObject();
        this.$http
          .post(ROUTES.DASHBOARD.DISCOUNTS.SAVE_DISCOUNT_CUFE, send)
          .then(({data}) => {
            if (data.code <= 0) {
              this.toast(data.message, TOAST_TYPES.ERROR);
              return;
            }
            this.toast(data.message, TOAST_TYPES.SUCCESS);
            this.cleanForm();
            this.getCufeDiscounts();
          })
          .catch(() => {
            this.toast("Ocurrió un error al guardar el descuento", TOAST_TYPES.ERROR);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },

    openDeleteModal() {
      confirmation(this, "¿Desea eliminar el descuento?").then((result) => {
        if (!result) {
          return;
        }
        this.deleteCufe();
      });
    },

    deleteCufe() {
      this.isLoading = true;
      this.$http
        .delete(ROUTES.DASHBOARD.DISCOUNTS.DELETE_DISCOUNT_CUFE, {
          params: { id: this.client_id }
        })
        .then(({data}) => {
          if (data.code <= 0) {
            this.toast(data.message, TOAST_TYPES.ERROR);
            return;
          }
          this.toast(data.message, TOAST_TYPES.SUCCESS);
          this.cleanForm();
          this.getCufeDiscounts();
        })
        .catch(() => {
          this.toast("Ocurrió un error al eliminar el descuento", TOAST_TYPES.ERROR);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /**
     * Trae del backend la lista de reglas CUFE ya creadas para la compañía actual.
     * Reemplaza el arreglo mockeado que había en tableData.
     */
    getCufeDiscounts() {
      if (!this.company) {
        this.tableData = [];
        return;
      }
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.DISCOUNTS.GET_DISCOUNT_CUFE, {
          params: {companyId: this.company}
        })
        .then(({data}) => {
            if (data.code <= 0) {
              this.toast(data.message, TOAST_TYPES.ERROR);
              this.isLoading = false;
              this.tableData = [];
              return;
            }
          this.tableData = (data.code > 0 ? data.info : []).map((row) => ({
            code: row.rangesCode,
            client: {
              id: row.clientId,
              code: row.clientCode,
              name: row.clientName,
              identification: row.clientIdentification
            },
            ranges: {
              code: row.rangesCode,
              initialValue: row.initialValue,
              finalValue: row.finalValue
            },
            voucher: {
              code: row.voucherCode,
              title: row.voucherTitle
            }
          }));
          this.$nextTick(() => { this.tableKey++; });
        })
        .catch(() => {
          this.tableData = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    }

  }
}
</script>

<style scoped>
.discount-table-cufe {
  position: relative;
  z-index: 1;
}

.discount-table-cufe {
  position: relative;
  z-index: 1;
}

.discount-table-cufe >>> .con-input-search{
  width:50%;
  max-width:400px;
}

.discount-table-cufe >>> .vs-table--search-input{
  width:100%;
  height:42px;
  font-size:19px;
  border:1px solid #D4D4D4;
  border-radius: 8px;
  border-block-color: #167df0;
  box-sizing:border-box;
  padding-block: 16px;
}
</style>